(function () {
  const ROOT_SELECTOR = '.user-login-cta';
  const CONTAINER_SELECTOR = '[user-login-cta-container]';
  const INFO_SELECTOR = '.user-login-cta__metric-info';
  const OPEN_CLASS = 'is-tooltip-open';
  const BELOW_CLASS = 'user-login-cta__tooltip--below';
  const NAME_WRAPPED_CLASS = 'is-name-wrapped';
  const VIEWPORT_PADDING = 12;
  const GAP = 8;
  const LEVEL_PNG_MAP = {
    L1: 'L1.png',
    L2: 'L2.png',
    L3: 'L3.png',
    L4: 'L4.png',
    L5: 'L5.png',
  };
  const ACCOUNT_HOME_LEVEL_NAMES = {
      L1: 'Adventurer',
      L2: 'Pathfinder',
      L3: 'Pioneer',
      L4: 'Pro',
      L5: 'Trailblazer',
  };
  const RECORD_MODAL_ID = 'ulcta-record-modal';
  const RECORD_OPEN_SELECTOR = '[data-ulcta-record-open]';
  const MILES_RECORDS_PAGE_SIZE = 200;
  const RAYS_RECORDS_PAGE_SIZE = 100;
  const RECORD_SCROLL_LOAD_THRESHOLD = 50;
  const RECORD_TONE_CLASS = {
    positive: 'is-positive',
    negative: 'is-negative',
    muted: 'is-muted',
  };
  let recordModal = null;
  let authExpiredHandled = false;

  function isTokenExpiredResponse(resp) {
    if (!resp) return false;
    const code = String(resp.code || '').toUpperCase();
    const msg = String(resp.msg || resp.message || '').toUpperCase();
    return code === 'SEC003' || msg.includes('TOKEN_EXPIRED') || msg.includes('TOKEN EXPIRED');
  }

  function isAuthSessionExpiredError(error, loginStatus) {
    if (loginStatus && !loginStatus.accessToken && !loginStatus.refreshToken) {
      return true;
    }

    if (!error) return false;

    const message = String(error.message || error).toLowerCase();
    return (
      message.includes('refresh token') ||
      message.includes('refresh failed') ||
      message.includes('401') ||
      message.includes('unauthorized')
    );
  }

  function showGuestState(loginStatus) {
    const hasMemberUi = document.querySelector(`${CONTAINER_SELECTOR} .user-login-cta__card--member`);
    const hasHiddenGuest = document.querySelector('.user-login-cta__card--guest-hidden');
    if (!hasMemberUi && !hasHiddenGuest) return;
    if (authExpiredHandled) return;

    authExpiredHandled = true;

    if (recordModal?.close) {
      recordModal.close();
    }

    if (loginStatus?.clearCookies) {
      loginStatus.clearCookies();
    }

    document.querySelectorAll(CONTAINER_SELECTOR).forEach((root) => {
      const memberCard = root.querySelector('.user-login-cta__card--member');
      const guestCard = root.querySelector('.user-login-cta__card--guest');
      if (!memberCard && !guestCard?.classList.contains('user-login-cta__card--guest-hidden')) return;

      root.classList.add('is-auth-expired');

      if (guestCard) {
        guestCard.hidden = false;
        guestCard.removeAttribute('hidden');
        guestCard.style.removeProperty('display');
      }
    });
  }

  function hookUserLoginStatusExpiredHandler() {
    if (typeof UserLoginStatus === 'undefined' || UserLoginStatus.prototype._ulctaGuestHooked) return;

    UserLoginStatus.prototype._ulctaGuestHooked = true;
    const original = UserLoginStatus.prototype.handleLoginExpired;

    UserLoginStatus.prototype.handleLoginExpired = function handleLoginExpiredWithUlctaGuest() {
      if (typeof original === 'function') {
        original.call(this);
      }
      showGuestState(this);
    };
  }

  function positionTooltip(info) {
    const trigger = info.querySelector('.user-login-cta__info-trigger');
    const tooltip = info.querySelector('.user-login-cta__tooltip');
    if (!trigger || !tooltip) return;

    tooltip.classList.remove(BELOW_CLASS);

    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    let top = triggerRect.top - tooltipRect.height - GAP;
    if (top < VIEWPORT_PADDING) {
      top = triggerRect.bottom + GAP;
      tooltip.classList.add(BELOW_CLASS);
    }

    let left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
    const maxLeft = window.innerWidth - VIEWPORT_PADDING - tooltipRect.width;
    left = Math.max(VIEWPORT_PADDING, Math.min(left, maxLeft));

    const arrowLeft = triggerRect.left + triggerRect.width / 2 - left;
    tooltip.style.left = `${Math.round(left)}px`;
    tooltip.style.top = `${Math.round(top)}px`;
    tooltip.style.setProperty('--user-login-cta-tooltip-arrow-left', `${Math.round(arrowLeft)}px`);
  }

  function openTooltip(info) {
    const tooltip = info.querySelector('.user-login-cta__tooltip');
    if (!tooltip) return;

    info.classList.add(OPEN_CLASS);
    tooltip.style.left = '-9999px';
    tooltip.style.top = '0';
    positionTooltip(info);
  }

  function closeTooltip(info) {
    const tooltip = info.querySelector('.user-login-cta__tooltip');
    info.classList.remove(OPEN_CLASS);
    if (!tooltip) return;

    tooltip.style.left = '';
    tooltip.style.top = '';
    tooltip.style.removeProperty('--user-login-cta-tooltip-arrow-left');
    tooltip.classList.remove(BELOW_CLASS);
  }

  function bindInfo(info) {
    const trigger = info.querySelector('.user-login-cta__info-trigger');
    if (!trigger || trigger.dataset.tooltipBound === 'true') return;

    trigger.dataset.tooltipBound = 'true';

    trigger.addEventListener('mouseenter', () => openTooltip(info));
    trigger.addEventListener('mouseleave', () => closeTooltip(info));
    trigger.addEventListener('focus', () => openTooltip(info));
    trigger.addEventListener('blur', () => closeTooltip(info));
  }

  function repositionOpenTooltips(root) {
    root.querySelectorAll(`${INFO_SELECTOR}.${OPEN_CLASS}`).forEach(positionTooltip);
  }

  function updatePanelTopLevelFlow(root) {
    const panelTop = root?.querySelector('.user-login-cta__panel-top');
    const name = panelTop?.querySelector('.user-login-cta__name');
    if (!panelTop || !name) return;

    panelTop.classList.remove(NAME_WRAPPED_CLASS);
    void panelTop.offsetHeight;

    const styles = window.getComputedStyle(name);
    const lineHeight = parseFloat(styles.lineHeight);
    const singleLineHeight = Number.isFinite(lineHeight)
      ? lineHeight
      : parseFloat(styles.fontSize) * 1.5;
    const isWrapped = name.getBoundingClientRect().height > singleLineHeight * 1.25;

    panelTop.classList.toggle(NAME_WRAPPED_CLASS, isWrapped);
  }

  function setHighestLevelState(root, isHighest) {
    if (!root) return;

    const memberCard = root.querySelector('.user-login-cta__card--member');
    const raysCard = root.querySelector('.user-login-cta__card--rays');
    const templateTipText = root.querySelector('[data-user-login-cta-tip="template-text"]');
    const highestTip = root.querySelector('[data-user-login-cta-tip="highest"]');
    const progressTargetWrap = root.querySelector('[data-user-login-cta-progress-target-wrap]');

    if (memberCard) memberCard.classList.toggle('is-highest', isHighest);
    if (raysCard) raysCard.classList.toggle('is-highest', isHighest);
    if (templateTipText) templateTipText.hidden = isHighest;
    if (highestTip) highestTip.hidden = !isHighest;
    if (progressTargetWrap) progressTargetWrap.hidden = isHighest;
  }

  function updateMemberLevelClass(root, lv) {
    const memberCard = root?.querySelector('.user-login-cta__card--member');
    if (!memberCard) return;

    Array.from(memberCard.classList).forEach((className) => {
      if (className.startsWith('lv-')) {
        memberCard.classList.remove(className);
      }
    });

    const level = String(lv || '').trim().toUpperCase();
    if (/^L[1-5]$/.test(level)) {
      memberCard.classList.add(`lv-${level}`);
    }
  }

  function parseNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    const normalized = typeof value === 'string' ? value.replace(/,/g, '').trim() : value;
    const num = Number(normalized);
    return Number.isNaN(num) ? null : num;
  }

  function formatNumber(value) {
    const num = parseNumber(value);
    if (num === null) return '--';
    return Math.trunc(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function setValue(root, key, value) {
    root.querySelectorAll(`[data-user-login-cta-value="${key}"]`).forEach((el) => {
      el.textContent = value;
    });
  }

  function getUserLoginCtaAssetUrl(fileName) {
    const safeFileName = String(fileName || '').trim();
    if (!safeFileName) return '';

    const script = document.querySelector('script[src*="user-login-cta.js"]');
    if (!script?.src) return safeFileName;

    return script.src.replace(/user-login-cta\.js(\?.*)?$/, encodeURIComponent(safeFileName));
  }

  function renderMemberLevel(root, level) {
    const normalizedLevel = String(level || '').trim().toUpperCase();
    const levelText = getLevelDisplayText(normalizedLevel);
    const iconFile = LEVEL_PNG_MAP[normalizedLevel];
    const iconUrl = getUserLoginCtaAssetUrl(iconFile);

    root.querySelectorAll('[data-user-login-cta-value="member_level"]').forEach((el) => {
      el.textContent = '';

      if (iconUrl) {
        const icon = document.createElement('img');
        icon.className = 'user-login-cta__level-icon';
        icon.src = iconUrl;
        icon.alt = '';
        icon.loading = 'lazy';
        icon.setAttribute('aria-hidden', 'true');
        icon.addEventListener('error', () => icon.remove(), { once: true });
        el.appendChild(icon);
      }

      const text = document.createElement('span');
      text.className = 'user-login-cta__level-text';
      text.textContent = levelText;
      el.appendChild(text);
    });
  }

  function updateRaysBadgePlaceholders(root, worthAmount) {
    if (!root) return;

    root.querySelectorAll('.user-login-cta__badge').forEach((badge) => {
      if (badge.querySelector('[data-user-login-cta-value="rays_worth_amount"]')) return;

      const text = badge.textContent;
      if (text.includes('{amount}')) {
        badge.textContent = text.replace(/\{amount\}/g, worthAmount);
      }
    });
  }

  function getNextLevelCode(level) {
    if (!level) return null;
    const levelNum = parseInt(String(level).replace('L', ''), 10);
    if (Number.isNaN(levelNum) || levelNum >= 5) return null;
    return `L${levelNum + 1}`;
  }

  function getLevelDisplayText(level) {
    if (!level || level === '--') return '--';
    const levelName = ACCOUNT_HOME_LEVEL_NAMES[level];
    return levelName ? `${level}.${levelName}` : level;
  }

  function getProgressPercent(currentMiles, nextLvMinMiles, progressPercent, highestLevel) {
    if (highestLevel) return 100;

    const percent = Number(progressPercent);
    if (!Number.isNaN(percent) && progressPercent !== null && progressPercent !== undefined && progressPercent !== '') {
      return Math.min(100, Math.max(0, percent));
    }

    const current = parseNumber(currentMiles);
    const target = parseNumber(nextLvMinMiles);
    if (current !== null && target !== null && target > 0) {
      return Math.min(100, Math.max(0, (current / target) * 100));
    }

    return 0;
  }

  function getProgressTargetMiles(profile) {
    const target = parseNumber(profile.nextLvMinMiles);
    if (target !== null) return target;

    const current = parseNumber(profile.currentMiles);
    const remaining = parseNumber(profile.nextLvMiles);
    if (current !== null && remaining !== null) {
      return current + remaining;
    }

    return null;
  }

  function renderProfileMetrics(root, profile) {
    if (!root || !profile) return;

    setValue(root, 'miles_balance', formatNumber(profile.currentMiles));
    setValue(root, 'pending_miles', formatNumber(profile.pendingMiles));
    setValue(root, 'expiring_miles', formatNumber(profile.milesExpiringThisMonth));
  }

  function getSiteCountry() {
    return (window.renogyConfig?.country || window.Shopify?.country || 'US').toUpperCase();
  }

  function isJapanSite() {
    return getSiteCountry() === 'JP';
  }

  function getRaysCurrencySymbol() {
    const country = getSiteCountry();
    if (country === 'AU') return 'A$';
    if (country === 'CA') return 'C$';

    if (typeof Intl === 'undefined' || !window.Shopify?.currency?.active) {
      return '$';
    }

    try {
      const shopCurrency = window.Shopify.currency.active;
      const shopLocale = `${window.Shopify.locale || 'en'}-${window.Shopify.country || country || 'US'}`;
      const formatter = new Intl.NumberFormat(shopLocale, {
        style: 'currency',
        currency: shopCurrency,
      });
      const currencyPart = formatter.formatToParts(0).find((part) => part.type === 'currency');
      return currencyPart?.value || '$';
    } catch (error) {
      return '$';
    }
  }

  function formatRaysWorthAmount(raysBalance) {
    const rays = parseNumber(raysBalance);
    if (rays === null) return '--';

    const rate = isJapanSite() ? 2 : 200;
    const worth = Math.floor(rays / rate);
    const symbol = getRaysCurrencySymbol();

    return `${symbol}${worth.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  }

  function pickField(source, keys) {
    if (!source) return null;

    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      let value = source;

      if (key.includes('.')) {
        const parts = key.split('.');
        for (let j = 0; j < parts.length; j += 1) {
          value = value?.[parts[j]];
          if (value === null || value === undefined) break;
        }
      } else {
        value = source[key];
      }

      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }

    return null;
  }

  const RAYS_ASSETS_FIELD_MAP = {
    rays_balance: [
      'currentRays',
      'raysBalance',
      'availableRays',
      'currentBonusPoints',
      'rays.balance',
      'rays.available',
    ],
    pending_rays: [
      'pendingRays',
      'frozenRays',
      'pendingBonusPoints',
      'frozenBonusPoints',
      'rays.pending',
      'rays.frozen',
    ],
    expiring_rays: [
      'expiringRays',
      'raysExpiringThisYear',
      'expiringBonusPoints',
      'bonusPointsExpiringThisMonth',
      'rays.expiringThisYear',
      'rays.expiring',
    ],
  };

  function renderRaysMetrics(root, assets) {
    if (!root || !assets) return;

    let raysBalanceRaw = pickField(assets, RAYS_ASSETS_FIELD_MAP.rays_balance);

    Object.keys(RAYS_ASSETS_FIELD_MAP).forEach((fieldKey) => {
      const value = pickField(assets, RAYS_ASSETS_FIELD_MAP[fieldKey]);
      if (value !== null) {
        if (fieldKey === 'rays_balance') {
          raysBalanceRaw = value;
        }
        setValue(root, fieldKey, formatNumber(value));
      }
    });

    const worthAmount = formatRaysWorthAmount(raysBalanceRaw);
    setValue(root, 'rays_worth_amount', worthAmount);
    updateRaysBadgePlaceholders(root, worthAmount);
  }

  /**
   * profile：用户信息、等级、进度、Miles 三列指标
   * assets：Rays 三列指标
   */
  function renderMemberData(root, profile, assets) {
    if (!root || !profile) return;

    const {
      lv,
      currentMiles,
      nextLvMiles,
      progressPercent,
      highestLevel,
    } = profile;

    const currentLevel = lv || '--';
    const normalizedLevel = String(currentLevel).trim().toUpperCase();
    const nextLevel = getNextLevelCode(currentLevel);
    const isHighest = Boolean(highestLevel) || normalizedLevel === 'L5';
    const progressTargetMiles = getProgressTargetMiles(profile);

    renderMemberLevel(root, currentLevel);

    setValue(root, 'progress_current', formatNumber(currentMiles));

    if (isHighest || progressTargetMiles === null) {
      setValue(root, 'progress_target', '--');
    } else {
      setValue(root, 'progress_target', formatNumber(progressTargetMiles));
    }

    const remainingMiles = parseNumber(nextLvMiles);
    if (isHighest || !nextLevel || remainingMiles === null) {
      setValue(root, 'progress_tip_value', '--');
      setValue(root, 'progress_tip_level', '--');
    } else {
      setValue(root, 'progress_tip_value', `+${formatNumber(nextLvMiles)}`);
      setValue(root, 'progress_tip_level', nextLevel);
    }

    const progressBar = root.querySelector('[data-user-login-cta-value="progress_percent"]');
    if (progressBar) {
      const percent = getProgressPercent(
        currentMiles,
        progressTargetMiles,
        progressPercent,
        isHighest
      );
      progressBar.style.width = `${percent}%`;
    }

    renderProfileMetrics(root, profile);
    renderRaysMetrics(root, assets);

    updateMemberLevelClass(root, currentLevel);
    setHighestLevelState(root, isHighest);
    window.requestAnimationFrame(() => updatePanelTopLevelFlow(root));
  }

  function renderAll(profile, assets) {
    if (!profile) return;

    document.querySelectorAll(CONTAINER_SELECTOR).forEach((root) => {
      if (!root.querySelector('.user-login-cta__card--member')) return;
      renderMemberData(root, profile, assets);
    });
  }

  function waitForUserLoginStatus(maxWait = 10000) {
    return new Promise((resolve, reject) => {
      const startedAt = Date.now();

      const check = () => {
        if (typeof UserLoginStatus !== 'undefined') {
          hookUserLoginStatusExpiredHandler();
          resolve(new UserLoginStatus());
          return;
        }

        if (Date.now() - startedAt > maxWait) {
          reject(new Error('[UserLoginCta] UserLoginStatus not available'));
          return;
        }

        setTimeout(check, 50);
      };

      check();
    });
  }

  function getAcceptLanguage() {
    const shopifyLocale = (window.Shopify?.locale || 'en').toLowerCase();
    const shopifyCountry = (window.Shopify?.country || 'US').toUpperCase();
    const langKey = shopifyLocale.split('-')[0];
    const localeMap = {
      en: 'en-US',
      de: 'de-DE',
      ja: 'ja-JP',
      zh: 'zh-CN',
      cs: 'cs-CZ',
      da: 'da-DK',
      es: 'es-ES',
      fr: shopifyCountry === 'CA' ? 'fr-CA' : 'fr-FR',
      it: 'it-IT',
      nl: 'nl-NL',
      pl: 'pl-PL',
      ru: 'ru-RU',
      tr: 'tr-TR',
      uk: 'uk-UA',
      pt: 'pt-PT',
      ko: 'ko-KR',
      sv: 'sv-SE',
    };

    return localeMap[langKey] || 'en-US';
  }

  async function fetchMemberCenterData(loginStatus) {
    const storeId = loginStatus.storeId;
    const acceptLanguage = getAcceptLanguage();
    let profileResp;
    let assetsResp;

    try {
      [profileResp, assetsResp] = await Promise.all([
        loginStatus._requestDtc(`/member-center/profile?storeId=${storeId}`, { method: 'GET', acceptLanguage }),
        loginStatus._requestDtc('/member-center/assets', { method: 'GET', acceptLanguage }),
      ]);
    } catch (error) {
      if (isAuthSessionExpiredError(error, loginStatus)) {
        showGuestState(loginStatus);
      }
      throw error;
    }

    if (
      isTokenExpiredResponse(profileResp) ||
      isTokenExpiredResponse(assetsResp) ||
      !loginStatus.accessToken ||
      !loginStatus.refreshToken
    ) {
      showGuestState(loginStatus);
      return { profile: null, assets: null };
    }

    const profile = profileResp?.code === '000000' ? profileResp.data : null;
    const assets = assetsResp?.code === '000000' ? assetsResp.data : null;

    if (!profile && profileResp?.code && profileResp.code !== '000000') {
      showGuestState(loginStatus);
      return { profile: null, assets: null };
    }

    if (profile) {
      loginStatus.memberCenterProfile = profile;
    }
    if (assets) {
      loginStatus.memberCenterAssets = assets;
    }

    return { profile, assets };
  }

  async function fetchAndRenderMemberData(root) {
    if (!root || root.dataset.memberDataLoaded === 'true') return;
    if (!root.querySelector('.user-login-cta__card--member')) return;
    if (root.classList.contains('is-auth-expired')) return;

    let loginStatus;
    try {
      loginStatus = await waitForUserLoginStatus();
      if (!loginStatus.accessToken || !loginStatus.refreshToken) {
        showGuestState(loginStatus);
        return;
      }

      const { profile, assets } = await fetchMemberCenterData(loginStatus);
      if (authExpiredHandled) return;
      if (!profile) return;

      renderMemberData(root, profile, assets);
      if (assets) {
        root.dataset.memberDataLoaded = 'true';
      }
    } catch (error) {
      if (!authExpiredHandled && isAuthSessionExpiredError(error, loginStatus)) {
        showGuestState(loginStatus);
        return;
      }
      console.error('[UserLoginCta] member-center data error:', error);
    }
  }

  async function fetchAndRenderAll() {
    const roots = document.querySelectorAll(CONTAINER_SELECTOR);
    if (!roots.length) return;

    await Promise.all(Array.from(roots).map(fetchAndRenderMemberData));
  }

  class UlctaRecordModal {
    constructor() {
      this.modalEl = document.getElementById(RECORD_MODAL_ID);
      if (!this.modalEl) return;

      this.loginStatus = null;
      this.userInformation = null;
      this.assetsInformation = null;
      this.milesRecordsItems = [];
      this.frozenMilesRecordsItems = [];
      this.raysRecordsItems = [];
      this.frozenRaysRecordsItems = [];
      this.frozenRaysRecordsInformation = null;
      this.milesRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.frozenMilesRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.raysRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.frozenRaysRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.milesRecordRows = { balance: [], pending: [] };
      this.raysRecordRows = { balance: [], pending: [] };
      this.milesRecordSubview = 'balance';
      this.raysRecordSubview = 'balance';
      this.bound = false;
      this.scrollBound = false;
      this.scrollRaf = null;
      this.modalScrollY = 0;
      this.closeTimer = null;
      this.lastOpener = null;

      this.bind();
    }

    async getLoginStatus() {
      if (!this.loginStatus) {
        this.loginStatus = await waitForUserLoginStatus();
      }
      return this.loginStatus;
    }

    async requestDtc(apiPath, options = {}) {
      try {
        const loginStatus = await this.getLoginStatus();
        const resp = await loginStatus._requestDtc(apiPath, {
          acceptLanguage: getAcceptLanguage(),
          ...options,
        });
        if (isTokenExpiredResponse(resp) || !loginStatus.accessToken || !loginStatus.refreshToken) {
          showGuestState(loginStatus);
        }
        return resp;
      } catch (error) {
        if (isAuthSessionExpiredError(error, this.loginStatus)) {
          showGuestState(this.loginStatus);
        }
        throw error;
      }
    }

    async requestBigcommerce(apiPath, options = {}) {
      try {
        const loginStatus = await this.getLoginStatus();
        const resp = await loginStatus._request(apiPath, {
          acceptLanguage: getAcceptLanguage(),
          ...options,
        });
        if (isTokenExpiredResponse(resp) || !loginStatus.accessToken || !loginStatus.refreshToken) {
          showGuestState(loginStatus);
        }
        return resp;
      } catch (error) {
        if (isAuthSessionExpiredError(error, this.loginStatus)) {
          showGuestState(this.loginStatus);
        }
        throw error;
      }
    }

    getMilesRecordsQuery(pageNum) {
      return `pageNum=${pageNum}&pageSize=${MILES_RECORDS_PAGE_SIZE}`;
    }

    getRaysRecordsQuery(pageNum) {
      return `pageNum=${pageNum}&pageSize=${RAYS_RECORDS_PAGE_SIZE}`;
    }

    mergeMilesRecordsPage(data, pageNum, append) {
      const items = Array.isArray(data?.userMilesLogContents) ? data.userMilesLogContents : [];

      if (append) {
        this.milesRecordsItems = this.milesRecordsItems.concat(items);
      } else {
        this.milesRecordsItems = items;
      }

      this.milesRecordsPagination.pageNum = pageNum;

      const total = Number(data?.total);
      if (Number.isFinite(total) && total >= 0) {
        this.milesRecordsPagination.hasMore = this.milesRecordsItems.length < total;
      } else {
        this.milesRecordsPagination.hasMore = items.length === MILES_RECORDS_PAGE_SIZE;
      }
    }

    mergeFrozenMilesRecordsPage(data, pageNum, append) {
      const items = Array.isArray(data?.frozenRecords) ? data.frozenRecords : [];

      if (append) {
        this.frozenMilesRecordsItems = this.frozenMilesRecordsItems.concat(items);
      } else {
        this.frozenMilesRecordsItems = items;
      }

      this.frozenMilesRecordsPagination.pageNum = pageNum;

      const total = Number(data?.total);
      if (Number.isFinite(total) && total >= 0) {
        this.frozenMilesRecordsPagination.hasMore = this.frozenMilesRecordsItems.length < total;
      } else {
        this.frozenMilesRecordsPagination.hasMore = items.length === MILES_RECORDS_PAGE_SIZE;
      }
    }

    mergeRaysRecordsPage(data, pageNum, append) {
      const items = Array.isArray(data?.contentList) ? data.contentList : [];

      if (append) {
        this.raysRecordsItems = this.raysRecordsItems.concat(items);
      } else {
        this.raysRecordsItems = items;
      }

      this.raysRecordsPagination.pageNum = pageNum;

      const total = Number(data?.total);
      if (Number.isFinite(total) && total >= 0) {
        this.raysRecordsPagination.hasMore = this.raysRecordsItems.length < total;
      } else {
        this.raysRecordsPagination.hasMore = items.length === RAYS_RECORDS_PAGE_SIZE;
      }
    }

    mergeFrozenRaysRecordsPage(data, pageNum, append) {
      const items = Array.isArray(data?.contentList) ? data.contentList : [];

      if (append) {
        this.frozenRaysRecordsItems = this.frozenRaysRecordsItems.concat(items);
      } else {
        this.frozenRaysRecordsItems = items;
      }

      this.frozenRaysRecordsInformation = data;
      this.frozenRaysRecordsPagination.pageNum = pageNum;

      const total = Number(data?.total);
      if (Number.isFinite(total) && total >= 0) {
        this.frozenRaysRecordsPagination.hasMore = this.frozenRaysRecordsItems.length < total;
      } else {
        this.frozenRaysRecordsPagination.hasMore = items.length === RAYS_RECORDS_PAGE_SIZE;
      }
    }

    async fetchUserInformation() {
      const loginStatus = await this.getLoginStatus();
      const profile = loginStatus.memberCenterProfile || (await loginStatus.getMemberCenterProfile());
      this.userInformation = profile;
      return profile;
    }

    async fetchAssetsInformation() {
      const loginStatus = await this.getLoginStatus();
      const assets = loginStatus.memberCenterAssets || (await loginStatus.getMemberCenterAssets());
      this.assetsInformation = assets;
      return assets;
    }

    async fetchMilesRecordsInformation(pageNum = 1, { append = false } = {}) {
      const resp = await this.requestDtc(`/member-center/miles-records?${this.getMilesRecordsQuery(pageNum)}`, {
        method: 'GET',
      });

      if (resp.code === '000000') {
        this.mergeMilesRecordsPage(resp.data, pageNum, append);
        return resp.data;
      }

      return null;
    }

    async fetchFrozenMilesRecordsInformation(pageNum = 1, { append = false } = {}) {
      const resp = await this.requestDtc(`/member-center/frozen-miles-records?${this.getMilesRecordsQuery(pageNum)}`, {
        method: 'GET',
      });

      if (resp.code === '000000') {
        this.mergeFrozenMilesRecordsPage(resp.data, pageNum, append);
        return resp.data;
      }

      return null;
    }

    async fetchRaysRecordsInformation(pageNum = 1, { append = false } = {}) {
      const resp = await this.requestBigcommerce(`/page_user_points_details?${this.getRaysRecordsQuery(pageNum)}`, {
        method: 'GET',
      });

      if (resp && resp.code === '000000') {
        this.mergeRaysRecordsPage(resp.data, pageNum, append);
        return resp.data;
      }

      return null;
    }

    async fetchFrozenRaysRecordsInformation(pageNum = 1, { append = false } = {}) {
      const resp = await this.requestBigcommerce(`/page_user_frozen_points_details?${this.getRaysRecordsQuery(pageNum)}`, {
        method: 'GET',
      });

      if (resp && resp.code === '000000') {
        this.mergeFrozenRaysRecordsPage(resp.data, pageNum, append);
        return resp.data;
      }

      return null;
    }

    async initRecordData() {
      this.milesRecordsItems = [];
      this.frozenMilesRecordsItems = [];
      this.raysRecordsItems = [];
      this.frozenRaysRecordsItems = [];
      this.frozenRaysRecordsInformation = null;
      this.milesRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.frozenMilesRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.raysRecordsPagination = { pageNum: 0, hasMore: false, loading: false };
      this.frozenRaysRecordsPagination = { pageNum: 0, hasMore: false, loading: false };

      await Promise.all([
        this.fetchMilesRecordsInformation(1),
        this.fetchFrozenMilesRecordsInformation(1),
        this.fetchRaysRecordsInformation(1),
        this.fetchFrozenRaysRecordsInformation(1),
      ]);

      this.buildMilesRecordRows();
      this.buildRaysRecordRows();
    }

    async ensureModalData() {
      const tasks = [];

      if (!this.userInformation) {
        tasks.push(this.fetchUserInformation());
      }

      if (!this.assetsInformation) {
        tasks.push(this.fetchAssetsInformation());
      }

      if (this.milesRecordsPagination.pageNum <= 0 || this.raysRecordsPagination.pageNum <= 0) {
        tasks.push(this.initRecordData());
      }

      if (tasks.length) {
        await Promise.all(tasks);
        return;
      }

      this.buildMilesRecordRows();
      this.buildRaysRecordRows();
    }

    formatRecordMiles(miles) {
      const num = Number(miles);
      if (!Number.isFinite(num)) return '--';
      const prefix = num > 0 ? '+' : '';
      return `${prefix}${formatNumber(num)} Miles`;
    }

    formatRecordRays(value, bonusPointsType) {
      const num = Number(value);
      if (!Number.isFinite(num)) return '--';

      const type = Number(bonusPointsType);
      let signed = num;
      if (type === 1 && num > 0) {
        signed = -num;
      } else if (type === 0 && num < 0) {
        signed = Math.abs(num);
      }

      const prefix = signed > 0 ? '+' : '';
      return `${prefix}${formatNumber(signed)} Rays`;
    }

    formatRecordTimestamp(timestamp) {
      if (timestamp == null || timestamp === '') return '--';

      let ms = Number(timestamp);
      if (!Number.isFinite(ms) || ms <= 0) {
        const parsed = Date.parse(String(timestamp));
        ms = Number.isFinite(parsed) ? parsed : NaN;
      }
      if (!Number.isFinite(ms) || ms <= 0) return '--';

      const date = new Date(ms);
      if (Number.isNaN(date.getTime())) return '--';

      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    formatRecordDateOnly(dateValue) {
      if (dateValue == null || dateValue === '') return '--';

      const raw = String(dateValue).split(/[T\s]/)[0];
      const parts = raw.split('-');
      if (parts.length === 3) {
        const year = parts[0];
        const month = Number(parts[1]);
        const day = String(parts[2]).padStart(2, '0');
        return `${year}-${month}-${day} 00:00`;
      }

      return this.formatRecordTimestamp(dateValue);
    }

    getMilesRecordStatusLabel(status) {
      const value = Number(status);
      if (value === 1) return 'Arrived';
      if (value === 2) return 'Expired';
      if (value === 3) return 'Deducted';
      return '--';
    }

    getMilesRecordStatusTone(status) {
      const value = Number(status);
      if (value === 1) return 'positive';
      if (value === 2) return 'negative';
      if (value === 3) return 'muted';
      return 'muted';
    }

    getMilesRecordNumberTone(miles) {
      const num = Number(miles);
      if (!Number.isFinite(num) || num === 0) return 'muted';
      return num > 0 ? 'positive' : 'negative';
    }

    getRaysRecordStatusLabel(status) {
      const value = Number(status);
      if (value === 1) return 'Arrived';
      if (value === 0) return 'Pending';
      return '--';
    }

    getRaysRecordStatusTone(status) {
      const value = Number(status);
      if (value === 1) return 'positive';
      if (value === 0) return 'muted';
      return 'muted';
    }

    getRaysRecordNumberTone(value, bonusPointsType) {
      const num = Number(value);
      if (!Number.isFinite(num) || num === 0) return 'muted';

      const type = Number(bonusPointsType);
      if (type === 1) return 'negative';
      if (type === 0) return 'positive';
      return num > 0 ? 'positive' : 'negative';
    }

    getRaysTaskName(item) {
      return item?.bpTaskDescriptionEn || item?.bpTaskDescription || item?.taskName || item?.taskCode || '--';
    }

    mapMilesLogToRow(item) {
      const miles = Number(item?.miles);
      return {
        date: this.formatRecordTimestamp(item?.createTimestamp),
        type: item?.taskName || item?.taskCode || '--',
        desc: item?.description || item?.taskName || '--',
        number: this.formatRecordMiles(miles),
        tone: this.getMilesRecordNumberTone(miles),
        state: this.getMilesRecordStatusLabel(item?.status),
        stateTone: this.getMilesRecordStatusTone(item?.status),
      };
    }

    mapFrozenMilesRecordToRow(item) {
      const miles = Number(item?.miles);
      return {
        date: this.formatRecordTimestamp(item?.frozenTimestamp),
        type: 'Order',
        desc: item?.spOrderName || '--',
        number: this.formatRecordMiles(miles),
        tone: 'muted',
        state: Number(item?.status) === 2 ? 'Released' : 'Pending',
        stateTone: 'muted',
      };
    }

    mapRaysLogToRow(item) {
      return {
        date: this.formatRecordTimestamp(item?.createDate ?? item?.updateDate),
        type: item?.taskCategory ?? '',
        desc: this.getRaysTaskName(item),
        number: this.formatRecordRays(item?.bonusPointsValue, item?.bonusPointsType),
        tone: this.getRaysRecordNumberTone(item?.bonusPointsValue, item?.bonusPointsType),
        state: this.getRaysRecordStatusLabel(item?.status),
        stateTone: this.getRaysRecordStatusTone(item?.status),
      };
    }

    mapFrozenRaysRecordToRow(item) {
      const points = Number(item?.frozenBonusPoints);
      return {
        date: this.formatRecordDateOnly(item?.expectedReleaseDate),
        type: 'Order',
        desc: item?.spOrderName || '--',
        number: this.formatRecordRays(points, 0),
        tone: 'muted',
        state: 'Pending',
        stateTone: 'muted',
      };
    }

    buildMilesRecordRows() {
      this.milesRecordRows = {
        balance: this.milesRecordsItems.map((item) => this.mapMilesLogToRow(item)),
        pending: this.frozenMilesRecordsItems.map((item) => this.mapFrozenMilesRecordToRow(item)),
      };
    }

    buildRaysRecordRows() {
      this.raysRecordRows = {
        balance: this.raysRecordsItems.map((item) => this.mapRaysLogToRow(item)),
        pending: this.frozenRaysRecordsItems.map((item) => this.mapFrozenRaysRecordToRow(item)),
      };
    }

    getRecordToneClass(tone) {
      return RECORD_TONE_CLASS[tone] || '';
    }

    getRecordLoadingText() {
      return this.modalEl?.getAttribute('data-i18n-loading') || 'Loading...';
    }

    buildRecordRowHtml(row, hideState) {
      const numberTone = hideState ? 'muted' : row.tone;
      const stateCell = hideState
        ? ''
        : `<td class="${this.getRecordToneClass(row.stateTone)}">${row.state}</td>`;

      return (
        `<tr>` +
        `<td>${row.date}</td>` +
        `<td>${row.type}</td>` +
        `<td>${row.desc}</td>` +
        `<td class="${this.getRecordToneClass(numberTone)}">${row.number}</td>` +
        stateCell +
        `</tr>`
      );
    }

    getRecordRows(key) {
      if (key === 'miles') {
        return this.milesRecordSubview === 'pending'
          ? (this.milesRecordRows.pending || [])
          : (this.milesRecordRows.balance || []);
      }

      if (key === 'rays') {
        return this.raysRecordSubview === 'pending'
          ? (this.raysRecordRows.pending || [])
          : (this.raysRecordRows.balance || []);
      }

      return [];
    }

    updateMilesRecordSummary() {
      const balanceEl = this.modalEl.querySelector('[data-ulcta-record-balance="miles"]');
      const pendingEl = this.modalEl.querySelector('[data-ulcta-record-pending="miles"]');
      const balanceText = formatNumber(this.userInformation?.currentMiles);
      const pendingText = formatNumber(this.userInformation?.pendingMiles);

      if (balanceEl) {
        balanceEl.textContent = balanceText;
        balanceEl.setAttribute('data-ulcta-record-balance-value', balanceText);
      }

      if (pendingEl) {
        pendingEl.textContent = pendingText;
      }
    }

    updateRaysRecordSummary() {
      const balanceEl = this.modalEl.querySelector('[data-ulcta-record-balance="rays"]');
      const pendingEl = this.modalEl.querySelector('[data-ulcta-record-pending="rays"]');
      const balanceText = formatNumber(this.assetsInformation?.raysBalance);
      const frozenTotal = Number(this.frozenRaysRecordsInformation?.totalFrozenPoints);
      const pendingValue = Number.isFinite(frozenTotal)
        ? frozenTotal
        : this.assetsInformation?.pendingRays;
      const pendingText = formatNumber(pendingValue);

      if (balanceEl) {
        balanceEl.textContent = balanceText;
        balanceEl.setAttribute('data-ulcta-record-balance-value', balanceText);
      }

      if (pendingEl) {
        pendingEl.textContent = pendingText;
      }
    }

    renderRecordTableRows(key) {
      const tbody = this.modalEl.querySelector(`[data-ulcta-record-rows="${key}"]`);
      if (!tbody) return;

      const rows = this.getRecordRows(key);
      const subview = key === 'miles' ? this.milesRecordSubview : this.raysRecordSubview;
      const hideState = subview === 'pending';

      tbody.innerHTML = rows.map((row) => this.buildRecordRowHtml(row, hideState)).join('');
    }

    appendRecordTableRows(key, startIndex) {
      const tbody = this.modalEl.querySelector(`[data-ulcta-record-rows="${key}"]`);
      if (!tbody) return;

      const rows = this.getRecordRows(key).slice(startIndex);
      if (!rows.length) return;

      const subview = key === 'miles' ? this.milesRecordSubview : this.raysRecordSubview;
      const hideState = subview === 'pending';
      const loadingRow = tbody.querySelector('[data-ulcta-record-loading]');
      const html = rows.map((row) => this.buildRecordRowHtml(row, hideState)).join('');

      if (loadingRow) {
        loadingRow.insertAdjacentHTML('beforebegin', html);
      } else {
        tbody.insertAdjacentHTML('beforeend', html);
      }
    }

    updateRecordLoadingRow(key, isLoading) {
      const tbody = this.modalEl.querySelector(`[data-ulcta-record-rows="${key}"]`);
      if (!tbody) return;

      const loadingRow = tbody.querySelector('[data-ulcta-record-loading]');

      if (isLoading) {
        if (!loadingRow) {
          tbody.insertAdjacentHTML(
            'beforeend',
            `<tr data-ulcta-record-loading class="ulcta-record-modal__loading-row"><td colspan="5">${this.getRecordLoadingText()}</td></tr>`
          );
        }
        return;
      }

      if (loadingRow) {
        loadingRow.remove();
      }
    }

    async loadMoreMilesRecordRows() {
      const isPending = this.milesRecordSubview === 'pending';
      const pagination = isPending ? this.frozenMilesRecordsPagination : this.milesRecordsPagination;

      if (pagination.loading || !pagination.hasMore) return;

      pagination.loading = true;
      this.updateRecordLoadingRow('miles', true);

      try {
        const prevRowCount = isPending
          ? this.milesRecordRows.pending.length
          : this.milesRecordRows.balance.length;
        const nextPage = pagination.pageNum + 1;

        if (isPending) {
          await this.fetchFrozenMilesRecordsInformation(nextPage, { append: true });
        } else {
          await this.fetchMilesRecordsInformation(nextPage, { append: true });
        }

        this.buildMilesRecordRows();
        this.appendRecordTableRows('miles', prevRowCount);
      } catch (error) {
        console.error('[UserLoginCta] load more miles records error:', error);
      } finally {
        pagination.loading = false;
        this.updateRecordLoadingRow('miles', false);
      }
    }

    async loadMoreRaysRecordRows() {
      const isPending = this.raysRecordSubview === 'pending';
      const pagination = isPending ? this.frozenRaysRecordsPagination : this.raysRecordsPagination;

      if (pagination.loading || !pagination.hasMore) return;

      pagination.loading = true;
      this.updateRecordLoadingRow('rays', true);

      try {
        const prevRowCount = isPending
          ? this.raysRecordRows.pending.length
          : this.raysRecordRows.balance.length;
        const nextPage = pagination.pageNum + 1;

        if (isPending) {
          await this.fetchFrozenRaysRecordsInformation(nextPage, { append: true });
        } else {
          await this.fetchRaysRecordsInformation(nextPage, { append: true });
        }

        this.buildRaysRecordRows();
        this.appendRecordTableRows('rays', prevRowCount);
      } catch (error) {
        console.error('[UserLoginCta] load more rays records error:', error);
      } finally {
        pagination.loading = false;
        this.updateRecordLoadingRow('rays', false);
      }
    }

    setRecordSubview(key, view) {
      const subview = view === 'pending' ? 'pending' : 'balance';

      if (key === 'miles') {
        this.milesRecordSubview = subview;
      } else if (key === 'rays') {
        this.raysRecordSubview = subview;
      }

      this.modalEl.querySelectorAll(`[data-ulcta-record-subtab="${key}"]`).forEach((btn) => {
        const active = btn.getAttribute('data-ulcta-record-subview') === subview;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      const label = this.modalEl.querySelector(`[data-ulcta-record-subvalue-label="${key}"]`);
      const valueEl = this.modalEl.querySelector(`[data-ulcta-record-balance="${key}"]`);
      const pendingEl = this.modalEl.querySelector(`[data-ulcta-record-pending="${key}"]`);

      if (label) {
        if (key === 'miles') {
          label.textContent = subview === 'pending'
            ? (this.modalEl.getAttribute('data-i18n-pending-miles-label') || 'Pending Miles:')
            : (this.modalEl.getAttribute('data-i18n-miles-balance-label') || 'Miles Balance:');
        } else if (key === 'rays') {
          label.textContent = subview === 'pending'
            ? (this.modalEl.getAttribute('data-i18n-pending-rays-label') || 'Pending Rays:')
            : (this.modalEl.getAttribute('data-i18n-rays-balance-label') || 'Rays Balance:');
        }
      }

      if (valueEl && pendingEl) {
        valueEl.textContent = subview === 'pending'
          ? pendingEl.textContent.trim()
          : (valueEl.getAttribute('data-ulcta-record-balance-value') || valueEl.textContent.trim());
      }

      const table = this.modalEl.querySelector(`[data-ulcta-record-panel="${key}"] .ulcta-record-modal__table`);
      if (table) {
        table.classList.toggle('is-pending-view', subview === 'pending');
      }

      this.renderRecordTableRows(key);
    }

    setRecordTab(key) {
      this.modalEl.querySelectorAll('[data-ulcta-record-tab]').forEach((btn) => {
        const active = btn.getAttribute('data-ulcta-record-tab') === key;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.modalEl.querySelectorAll('[data-ulcta-record-panel]').forEach((panel) => {
        const active = panel.getAttribute('data-ulcta-record-panel') === key;
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (key === 'miles') {
        this.setRecordSubview('miles', this.milesRecordSubview);
      } else if (key === 'rays') {
        this.setRecordSubview('rays', this.raysRecordSubview);
      }
    }

    renderRecord() {
      this.updateMilesRecordSummary();
      this.updateRaysRecordSummary();
      this.renderRecordTableRows('miles');
      this.renderRecordTableRows('rays');
    }

    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    lockScroll() {
      this.modalScrollY = window.scrollY;
      document.body.classList.add('ulcta-record-modal-open');
      document.body.style.top = `-${this.modalScrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }

    unlockScroll() {
      document.body.classList.remove('ulcta-record-modal-open');
      document.body.style.top = '';
      document.body.style.position = '';
      document.body.style.width = '';
      window.scrollTo(0, this.modalScrollY);
    }

    async open(tab, opener) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }

      this.lastOpener = opener || null;
      const activeTab = tab || 'miles';

      if (activeTab === 'miles') {
        this.setRecordSubview('miles', 'balance');
      } else if (activeTab === 'rays') {
        this.setRecordSubview('rays', 'balance');
      }

      try {
        await this.ensureModalData();
      } catch (error) {
        if (authExpiredHandled || isAuthSessionExpiredError(error, this.loginStatus)) {
          showGuestState(this.loginStatus);
          return;
        }
        console.error('[UserLoginCta] record modal data error:', error);
      }

      if (authExpiredHandled) return;

      this.renderRecord();
      this.setRecordTab(activeTab);

      this.modalEl.classList.remove('is-closing');
      this.modalEl.classList.add('is-open');
      this.modalEl.setAttribute('aria-hidden', 'false');
      this.lockScroll();

      const dialog = this.modalEl.querySelector('.ulcta-record-modal__dialog');
      if (dialog) {
        dialog.focus();
      }
    }

    close() {
      if (!this.modalEl.classList.contains('is-open')) return;

      if (this.lastOpener && typeof this.lastOpener.focus === 'function') {
        this.lastOpener.focus();
      }

      if (this.isMobile()) {
        this.modalEl.classList.add('is-closing');
        this.modalEl.setAttribute('aria-hidden', 'true');
        this.unlockScroll();

        this.closeTimer = window.setTimeout(() => {
          this.modalEl.classList.remove('is-open', 'is-closing');
          this.closeTimer = null;
        }, 300);
        return;
      }

      this.modalEl.classList.remove('is-open', 'is-closing');
      this.modalEl.setAttribute('aria-hidden', 'true');
      this.unlockScroll();
    }

    bindOpenButtons() {
      if (this.openDelegatedBound) return;
      this.openDelegatedBound = true;

      document.addEventListener('click', (event) => {
        const btn = event.target.closest(RECORD_OPEN_SELECTOR);
        if (!btn || !btn.closest(ROOT_SELECTOR)) return;

        event.preventDefault();
        this.open(btn.getAttribute('data-ulcta-record-open'), btn);
      });
    }

    bindRecordScroll() {
      if (this.scrollBound) return;
      this.scrollBound = true;

      const bindScrollLoad = (panelKey, loadMoreFn) => {
        const tableWrap = this.modalEl.querySelector(`[data-ulcta-record-panel="${panelKey}"] .ulcta-record-modal__table-wrap`);
        if (!tableWrap) return;

        tableWrap.addEventListener('scroll', () => {
          if (this.scrollRaf) return;

          this.scrollRaf = requestAnimationFrame(() => {
            this.scrollRaf = null;

            if (!this.modalEl?.classList.contains('is-open')) return;

            const { scrollTop, scrollHeight, clientHeight } = tableWrap;
            const distanceToBottom = scrollHeight - scrollTop - clientHeight;

            if (distanceToBottom <= RECORD_SCROLL_LOAD_THRESHOLD) {
              loadMoreFn.call(this);
            }
          });
        }, { passive: true });
      };

      bindScrollLoad('miles', this.loadMoreMilesRecordRows);
      bindScrollLoad('rays', this.loadMoreRaysRecordRows);
    }

    bind() {
      if (this.bound) return;
      this.bound = true;

      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        this.bindOpenButtons(root);
      });

      this.modalEl.querySelectorAll('[data-ulcta-record-close]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.close();
        });
      });

      this.modalEl.querySelectorAll('[data-ulcta-record-tab]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.setRecordTab(btn.getAttribute('data-ulcta-record-tab'));
        });
      });

      this.modalEl.querySelectorAll('[data-ulcta-record-subtab]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const recordKey = btn.getAttribute('data-ulcta-record-subtab');
          if (!recordKey) return;
          this.setRecordSubview(recordKey, btn.getAttribute('data-ulcta-record-subview'));
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modalEl.classList.contains('is-open')) {
          this.close();
        }
      });

      this.bindRecordScroll();
    }
  }

  function initRecordModal() {
    if (recordModal || !document.getElementById(RECORD_MODAL_ID)) return;
    recordModal = new UlctaRecordModal();
  }

  function init(root) {
    if (!root) return;

    root.querySelectorAll(INFO_SELECTOR).forEach(bindInfo);

    const memberCard = root.querySelector('.user-login-cta__card--member');
    if (memberCard) {
      setHighestLevelState(root, memberCard.classList.contains('is-highest'));
      window.requestAnimationFrame(() => updatePanelTopLevelFlow(root));
    }

    if (root.dataset.tooltipViewportBound === 'true') return;
    root.dataset.tooltipViewportBound = 'true';

    const onViewportChange = () => {
      repositionOpenTooltips(root);
      updatePanelTopLevelFlow(root);
    };
    window.addEventListener('scroll', onViewportChange, true);
    window.addEventListener('resize', onViewportChange);

    recordModal?.bindOpenButtons(root);
  }

  function verifyMemberSessionAfterInit() {
    window.setTimeout(async () => {
      if (authExpiredHandled) return;
      if (!document.querySelector(`${CONTAINER_SELECTOR} .user-login-cta__card--member`)) return;

      try {
        const loginStatus = await waitForUserLoginStatus();
        if (!loginStatus.accessToken || !loginStatus.refreshToken) {
          showGuestState(loginStatus);
        }
      } catch (error) {
        if (!authExpiredHandled && isAuthSessionExpiredError(error)) {
          showGuestState(await waitForUserLoginStatus().catch(() => null));
        }
      }
    }, 0);
  }

  function initAll() {
    hookUserLoginStatusExpiredHandler();
    initRecordModal();
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
    fetchAndRenderAll();
    verifyMemberSessionAfterInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (!root) return;

    initRecordModal();
    root.dataset.memberDataLoaded = 'false';
    init(root);
    fetchAndRenderMemberData(root);
  });

  window.UserLoginCta = window.UserLoginCta || {};
  window.UserLoginCta.setHighestLevelState = setHighestLevelState;
  window.UserLoginCta.renderMemberData = renderMemberData;
  window.UserLoginCta.renderProfileMetrics = renderProfileMetrics;
  window.UserLoginCta.renderRaysMetrics = renderRaysMetrics;
  window.UserLoginCta.renderAll = renderAll;
  window.UserLoginCta.fetchMemberCenterData = fetchMemberCenterData;
  window.UserLoginCta.fetchAndRenderAll = fetchAndRenderAll;
  window.UserLoginCta.showGuestState = showGuestState;
})();
